import { contactDetails } from './types';

export const requestFundingSearchContactDetails = (fundingSearchId) => ({
  type: contactDetails.request,
  fundingSearchId,
});
export const requestFundingSearchContactDetailsSuccess = (fundingSearchId, response) => ({
  type: contactDetails.success,
  fundingSearchId,
  response,
});
export const requestFundingSearchContactDetailsFailure = (fundingSearchId, error) => ({
  type: contactDetails.failure,
  fundingSearchId,
  error,
});
